module.exports = __webpack_public_path__ + "img/맥형띠배너bg_desktop.b6be6ffb.png";